var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 5.66667H8.9375V4.04762C8.9375 3.37302 8.70052 2.7996 8.22656 2.32738C7.7526 1.85516 7.17708 1.61905 6.5 1.61905C5.82292 1.61905 5.2474 1.85516 4.77344 2.32738C4.29948 2.7996 4.0625 3.37302 4.0625 4.04762H2.4375C2.4375 2.92778 2.83359 1.97321 3.62578 1.18393C4.41797 0.394643 5.37604 0 6.5 0C7.62396 0 8.58203 0.394643 9.37422 1.18393C10.1664 1.97321 10.5625 2.92778 10.5625 4.04762V5.66667H11.375C11.8219 5.66667 12.2044 5.8252 12.5227 6.14226C12.8409 6.45933 13 6.84048 13 7.28571V15.381C13 15.8262 12.8409 16.2073 12.5227 16.5244C12.2044 16.8415 11.8219 17 11.375 17H1.625C1.17812 17 0.795573 16.8415 0.477344 16.5244C0.159115 16.2073 0 15.8262 0 15.381V7.28571C0 6.84048 0.159115 6.45933 0.477344 6.14226C0.795573 5.8252 1.17812 5.66667 1.625 5.66667ZM1.625 15.381H11.375V7.28571H1.625V15.381ZM6.5 12.9524C6.94687 12.9524 7.32943 12.7938 7.64766 12.4768C7.96589 12.1597 8.125 11.7786 8.125 11.3333C8.125 10.8881 7.96589 10.5069 7.64766 10.1899C7.32943 9.87282 6.94687 9.71429 6.5 9.71429C6.05312 9.71429 5.67057 9.87282 5.35234 10.1899C5.03411 10.5069 4.875 10.8881 4.875 11.3333C4.875 11.7786 5.03411 12.1597 5.35234 12.4768C5.67057 12.7938 6.05312 12.9524 6.5 12.9524Z",
    fill: "#237FB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.11cf12c3fd8097140de3f2d6aeb8cfbb.svg";
export { ForwardRef as ReactComponent };